import Image from 'next/image'
import React from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { styled, Typography } from '@mui/material'

import { ourStoryData } from '../mocks/ourStory/data'

export const OurStoryMission: React.FC = () => {
  const { paragraphs, imagePath } = ourStoryData.mission

  return (
    <StyledSection>
      <StyledGrid>
        <StyledImageContainer>
          <StyledImageWrapper>
            <Image
              src={imagePath}
              alt="Sisters enjoying a personalised story together"
              fill
              style={{ objectFit: 'cover', borderRadius: pxToRem(16) }}
            />
          </StyledImageWrapper>
        </StyledImageContainer>
        <StyledTextContent>
          {paragraphs.map((paragraph, index) => (
            <StyledParagraph key={index} variant="body1">
              {paragraph}
            </StyledParagraph>
          ))}
        </StyledTextContent>
      </StyledGrid>
    </StyledSection>
  )
}

const StyledSection = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.custom.warmCream,
  padding: `${pxToRem(48)} ${pxToRem(24)}`,
  borderRadius: pxToRem(16),

  [theme.breakpoints.up('md')]: {
    padding: `${pxToRem(64)} ${pxToRem(48)}`,
  },
}))

const StyledGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(4),
  alignItems: 'center',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(6),
  },
}))

const StyledImageContainer = styled('div')({
  borderRadius: pxToRem(16),
  overflow: 'hidden',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
})

const StyledImageWrapper = styled('div')({
  position: 'relative',
  width: '100%',
  aspectRatio: '4/3',
})

const StyledTextContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: pxToRem(20),
})

const StyledParagraph = styled(Typography)(({ theme }) => ({
  fontSize: pxToRem(16),
  lineHeight: 1.8,
  color: theme.palette.primary.main,

  [theme.breakpoints.up('md')]: {
    fontSize: pxToRem(18),
  },
}))
